import $ from 'jquery';
import _ from 'ext:lodash';
import mapApi from 'vendor/google-maps-api';

function getIcon(color) {
	var mouseoverIcon = null;
	var mouseoutIcon = null;

	// replace # symbole with encoded string
	var markerColor = color.replace('#', '%23');

	var iconImage = 'data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2222%22%20height%3D%2232%22%3E%3Cpath%20fill%3D%22' + markerColor + '%22%20d%3D%22M11%2029.8L3%2017.4c-1.2-1.7-2-4.1-2-6.4C1%205.4%205.5%201%2011%201s10%204.6%2010%2010.3c0%202.2-.7%204.3-2%206.1l-8%2012.4z%22%2F%3E%3Cpath%20fill%3D%22none%22%20stroke%3D%22%23FFF%22%20stroke-opacity%3D%22.4%22%20d%3D%22M10.6%2030l-8-12.3C1.3%2015.9.5%2013.4.5%2011%20.5%205.1%205.2.5%2011%20.5s10.5%204.9%2010.5%2010.8c0%202.3-.7%204.6-2%206.4l-8.5%2013-.4-.7z%22%2F%3E%3Cpath%20fill%3D%22%23FFF%22%20d%3D%22M11%2018c3.9%200%207-3.1%207-7s-3.1-7-7-7-7%203.1-7%207%203.1%207%207%207z%22%2F%3E%3Cpath%20fill%3D%22' + markerColor + '%22%20d%3D%22M15%2011c0-2.2-1.8-4-4-4s-4%201.8-4%204%201.8%204%204%204%204-1.8%204-4z%22%2F%3E%3C%2Fsvg%3E';

	mouseoutIcon = {
		url: iconImage,
		scaledSize: new google.maps.Size(22, 32)
	};
	mouseoverIcon = {
		url: iconImage,
		scaledSize: new google.maps.Size(30, 44)
	};

	return {in: mouseoverIcon, out: mouseoutIcon};
}

function placeMarkers(map, markers) {
	_.forEach(markers, (m) => {
		var infoWindow;

		if(m.infoWindow) {
			var htmlContent = m.infoWindow.content.html.replace(/<p>/g, '<p class="m-b-0">');
			var iwContent = `
				<div class="iw-container">
					<div class="small">
						${htmlContent}
					</div>
				</div>
			`;

			infoWindow = new google.maps.InfoWindow({
				content: iwContent
			});
		}

		var icons = getIcon(m.icon.color);
		var mouseoverIcon = icons.in;
		var mouseoutIcon = icons.out;

		var apiMarker = new google.maps.Marker({
			position: {
				lat: m.location.lat,
				lng: m.location.lng
			},
			map: map,
			title: m.name,
			icon: mouseoutIcon
		});

		apiMarker.addListener('mouseover', function() {
			// setIcon function bound for mouseover
			apiMarker.setIcon(mouseoverIcon);
		});
		apiMarker.addListener('mouseout', function() {
			// setIcon function bound for mouseout
			apiMarker.setIcon(mouseoutIcon);
		});

		if(infoWindow) {
			apiMarker.addListener('click', ()=> {
				infoWindow.open(map, apiMarker);
				apiMarker.setIcon(mouseoverIcon);
			});
		}
	});
}

$(() => {
	var mainElement = $('#snazzy-map');
	var map;
	if(mainElement.length){
		var snazzyConfig = window.snazzyJson;
		var googleConfig = {
			center: {
				lat: snazzyConfig.location.center.lat,
				lng: snazzyConfig.location.center.lng
			},
			styles: snazzyConfig.style.json,
			zoom: snazzyConfig.location.zoom
		};

		mapApi.initialize().then(()=> {
			map = new google.maps.Map(document.getElementById('snazzy-map'), googleConfig);
			placeMarkers(map, snazzyConfig.markers);
		});
	}
});
